import { render, staticRenderFns } from "./bf-flex.vue?vue&type=template&id=f6fb0906&scoped=true&lang=pug&"
import script from "./bf-flex.vue?vue&type=script&lang=js&"
export * from "./bf-flex.vue?vue&type=script&lang=js&"
import style0 from "./bf-flex.vue?vue&type=style&index=0&id=f6fb0906&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fb0906",
  null
  
)

export default component.exports